import React, { useState } from 'react'
import BertholdTitle from 'src/components/atoms/bertholdTitle'

import {
  LocationsQuery,
  PrismicLinkType,
  PrismicStoreLocation,
} from 'src/typings/generated/graphql'

import WorldCupLocationsMap, {
  IVisibleLocation,
} from 'src/components/molecules/worldCupLocationsMap'
import CustomLink from 'src/utils/customLink'
import { generateRandomId } from 'src/utils/domHelper'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'radar-sdk-js/dist/radar.css'

import { graphql, useStaticQuery } from 'gatsby'
import {
  WORLD_CUP_2026_VENUES,
  WorldCupVenue,
} from 'src/constants/worldCupVenues'
import * as Styles from './worldCupLocator.module.scss'

export type WorldCupLocatorContent = {
  anchor?: string
  callout?: string
  link?: PrismicLinkType
  linkText?: string
}

type Props = {
  content: WorldCupLocatorContent
}

const WorldCupLocator = ({ content }: Props) => {
  const [selectedVenue, setSelectedVenue] = useState<WorldCupVenue>(
    WORLD_CUP_2026_VENUES[0]
  )
  const [visibleLocations, setVisibleLocations] = useState<IVisibleLocation[]>(
    []
  )

  const visibleLocationCount = visibleLocations.length

  const {
    anchor = generateRandomId(),
    callout = '',
    link,
    linkText = '',
  } = content

  const data: LocationsQuery = useStaticQuery(graphql`
    query WorldCupLocations {
      allPrismicStoreLocation {
        nodes {
          uid
          data {
            coordinates {
              latitude
              longitude
            }
            external_location_data {
              birthdate
              postal_code
              state
              city
              address1
            }
            override_external_zip_code
          }
        }
      }
    }
  `)

  const handleVenueChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const venue = WORLD_CUP_2026_VENUES[Number(e.target.value)]
    if (venue) setSelectedVenue(venue)
  }

  return (
    <section id={anchor} className={Styles.worldCupLocatorSlice}>
      <div className={Styles.mapContainer}>
        <WorldCupLocationsMap
          mapCenter={{
            lat: selectedVenue.latitude,
            lng: selectedVenue.longitude,
          }}
          locations={
            data.allPrismicStoreLocation.nodes as PrismicStoreLocation[]
          }
          setVisibleLocations={setVisibleLocations}
        />
      </div>
      <div className={Styles.contentContainer}>
        <div className={Styles.offsetBorder} />
        <div className={Styles.overlay}>
          <div className={Styles.content}>
            <h2>{BertholdTitle({ text: callout })}</h2>
            <p className={Styles.dropdownLabel}>Select a Venue</p>
            <select
              aria-label="Select a Venue"
              className={Styles.venueDropdown}
              onChange={handleVenueChange}
              value={WORLD_CUP_2026_VENUES.indexOf(selectedVenue)}
            >
              {WORLD_CUP_2026_VENUES.map((venue, idx) => (
                <option key={venue.name} value={idx}>
                  {venue.name} — {venue.city}
                </option>
              ))}
            </select>
            {visibleLocationCount > 0 && (
              <p>
                {`${visibleLocationCount} Raising Cane's near ${selectedVenue.name}`}
              </p>
            )}
            {link?.url && (
              <CustomLink className={Styles.goldButton} link={link}>
                {linkText}
              </CustomLink>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default WorldCupLocator
